export const setObjectPropertiesToNull = (object, exclude) => {
    const newObject = Object.entries(object)
        .map(([key, value]) => {
            if (exclude && exclude.has(key))
                return [key, value];
            return [key, null]
        }
        );
    return Object.fromEntries(newObject);
}